/**
 * Controller, resolves and related functionality for the dashboard view.
 */

export default function ContentDeveloperDashboardController (ErrorMessagingService) {
  ErrorMessagingService.clearErrors();
}